import { Field } from 'module/api/field/types';
import { MultiUserFieldFilter } from 'module/types/filter-field/filter/multi-user';
import { SelectFilterOperationType } from 'module/types/filter-field/filter/select';
import { isEqual } from 'lodash';
import type { FilterFunction } from 'module/ui/components/molecules/field-filter/types';
import { getFieldValue } from './get-field-value';

export const multi_user = (filter: MultiUserFieldFilter): FilterFunction => {
  const value = getFieldValue<number[]>(filter.field as any as Field);

  switch (filter.type) {
    case SelectFilterOperationType.IsEmpty:
      return (record) => value(record) == null;
    case SelectFilterOperationType.IsNotEmpty:
      return (record) => value(record) != null;
    case SelectFilterOperationType.Is:
      return (record) =>
        isEqual(new Set(value(record) ?? []), new Set(filter.value));
    case SelectFilterOperationType.IsNot:
      return (record) =>
        !isEqual(new Set(value(record) ?? []), new Set(filter.value));
    case SelectFilterOperationType.IsOneOf:
      return (record) => {
        const selected = value(record) ?? [];

        return filter.value!.some((v) => selected.includes(v));
      };
    case SelectFilterOperationType.IsNoneOf:
      return (record) => {
        const selected = value(record) ?? [];

        return filter.value!.every((v) => !selected.includes(v));
      };
    default:
      return () => true;
  }
};
